import {getMethod} from '@/api'

async function get(params) {
    return await getMethod('/api/searchTransfersResults', params, null, {responseType: 'arraybuffer'})
}

export {get}
